import { ProductGlobalModel } from 'src/app/domain/models/product-global.model';
import { Observable } from 'rxjs';
import { StorePublicModel } from '../models/store-public.model';


export abstract class ProductGlobalRepository {
    abstract getAll(id?: number): Observable<ProductGlobalModel[]>;
}
